/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useState, useContext, useEffect, Fragment } from 'react';
import { PropTypes } from 'prop-types';
import { ModalLost, ModalCancelEndorsement } from 'components/index';
import Button from 'components/Button';
import { useHistory } from 'react-router-dom';
import { FitinsurAPI, MessageCenter } from 'utils';
import { GlobalAuthContext, GlobalLoaderContext } from 'store/context';
import { Title } from 'components/Header/styles';

function LostCancelButton(props) {
  const [modalLostOpen, setModalLostOpen] = useState(false);
  const [modalCancelationOpen, setmodalCancelationOpen] = useState({ visible: false });
  const [isEndorsement, setIsEndorsement] = useState(false);
  const [shouldRenderAnyButton, setShouldRenderAnyButton] = useState(true);

  const history = useHistory();

  const authContext = useContext(GlobalAuthContext);

  const fitinsur = new FitinsurAPI();
  const mc = new MessageCenter();

  function getOperationInfo() {
    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestOperationInfo(props.idOperation)
      .then(response => response.json())
      .then(response => {
        if (response.idDomain !== 26) setIsEndorsement(true)
        if (response.isBound) setShouldRenderAnyButton(false)
      })
      .catch((error) => {
        mc.error("There was an error while fetching your data: \n" + error);
      });
  }

  useEffect(() => {
    getOperationInfo()
  }, [])

  const renderButton = (title) => {
    if (shouldRenderAnyButton && isEndorsement) {
      return (
        <Button
          type="button"
          third
          onClick={() => {
            setmodalCancelationOpen({ visible: true })
          }}
        >
          CANCEL
        </Button>
      )
    }

    if (shouldRenderAnyButton && !isEndorsement) {
      return (
        <Button
          type="button"
          third
          onClick={() => {
            setModalLostOpen(true)
          }}
        >
          {props.title ? props.title : 'CANCELAR'}
        </Button>
      )
    }

    return <div />
  }

  return (
    <div>
      <ModalCancelEndorsement
        history={history}
        show={modalCancelationOpen.visible}
        setDialog={setmodalCancelationOpen}
        idOperation={props.idOperation}
      />

      <ModalLost
        idOperation={props.idOperation}
        show={modalLostOpen}
        setDialog={setModalLostOpen}
        history={history}
      />

      {renderButton()}

    </div>
  );
}

const propTypes = {
  isEndorsement: PropTypes.bool,
}

LostCancelButton.prototype = propTypes;
export default LostCancelButton;